<template>
    <div v-if="contentText !== ''" ref="stretchBox" class="stretch-box" style="max-height: 239px;">
        <h1 class="stretch-box-title">{{ title }}</h1>
        <div class="stretch-box-content" v-html="contentText"></div>
        <p ref="stretchBtn" class="stretch-box-btn" @click="toStretch()">展开<van-icon name="arrow-down" />
        </p>
    </div>
</template>

<script>
export default {
    props: ["title", "contentText"],
    updated() {
        let dom = this.$refs.stretchBox;
        let dom2 = this.$refs.stretchBtn;
        setTimeout(() => {
            if (dom.scrollHeight > 239 && dom.style.maxHeight === "239px") {
                dom2.style.display = "block";
            }
        }, 0);

    },
    methods: {
        toStretch() {
            this.$refs.stretchBox.style.maxHeight = "100%";
            this.$refs.stretchBtn.style.display = "none";
        },
    }

}

</script>

<style lang='scss' scoped>
.stretch-box {
    position: relative;
    margin-top: 12px;
    padding: 15px 12px;
    width: 100%;
    background-color: #FFFFFF;
    border-radius: 8px;
    overflow: hidden;

    .stretch-box-title {
        margin-bottom: 15px;
        font-size: 17px;
        color: #333333;
        line-height: 24px;
    }

    .stretch-box-content {
        font-size: 16px;
        line-height: 2;

        &::v-deep img {
            width: 100%;
            height: 100%;
        }

        &::v-deep p {
            word-wrap: break-word;
        }
    }

    .stretch-box-btn {
        display: none;
        position: absolute;
        bottom: 0;
        left: 0;
        padding: 15px 0 17px;
        width: 100%;
        background-color: #fff;
        font-size: 13px;
        color: #999999;
        line-height: 19px;
        text-align: center;

        &::v-deep .van-icon {
            margin-left: 3px;
        }
    }
}
</style>